"use strict";

import wNumb from 'wnumb';

export function initInScope($scope) {

    let $rangeSlider = $scope.find('.js-range-slider');
    let $findologicSearch = $scope.find('.js-findologic-search');

    import('nouislider').then(function (noUiSlider) {
        $rangeSlider.each(function () {
            let $this = $(this),
                slider = $this.find('.js-range-slider__slider')[0],

                minValue = $this.data('min-value') || 0,
                maxValue = $this.data('max-value') || 100,

                $minInput = $this.find('.js-range-slider__min'),
                $maxInput = $this.find('.js-range-slider__max'),

                // container where the values get pushed
                $minValueText = $this.find('.js-range-slider__val-min'),
                $maxValueText = $this.find('.js-range-slider__val-max'),

                decimalPlaces = 0,

                prefix = $this.data('prefix') || '',
                suffix = $this.data('suffix') || '',

                startMin = minValue,
                startMax = maxValue;

            if (_config.findologicSearch && window.location.search) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const urlPriceMin = urlParams.get('price[min]');
                const urlPriceMax = urlParams.get('price[max]');

                try {
                    if (!window.sessionStorage.getItem('priceFilter')) {
                        // $minInput.attr('disabled', true);
                        // $maxInput.attr('disabled', true);
                    } else if(urlPriceMin || urlPriceMax) {

                        let storageMinInputVal = window.sessionStorage.getItem($minInput.attr('name'));
                        let storageMaxInputVal = window.sessionStorage.getItem($maxInput.attr('name'));

                        $minInput.val(storageMinInputVal);
                        $maxInput.val(storageMaxInputVal);

                        $minInput.attr('disabled', false);
                        $maxInput.attr('disabled', false);
                    }

                } catch (e) {
                    console.log(e);
                }
            }

            if ($minInput.val()) {
                startMin = $minInput.val();
            } else {
                startMin = minValue;
            }
            if ($maxInput.val()) {
                startMax = $maxInput.val();
            } else {
                startMax = maxValue;
            }

            noUiSlider.create(slider, {
                range: {
                    'min': [minValue],
                    'max': [maxValue]
                },
                tooltips: false,
                start: [startMin, startMax],
                step: 0,
                connect: true
            });

            $minInput.val(startMin);
            $minInput.attr('max', maxValue);
            $minInput.attr('min', minValue);
            $maxInput.val(startMax);
            $maxInput.attr('max', maxValue);
            $maxInput.attr('min', minValue);

            slider.noUiSlider.on('update', function (values, handle) {
                let value = +values[handle];

                if (handle) {
                    $maxInput.val(value.toFixed(decimalPlaces));
                } else {
                    $minInput.val(value.toFixed(decimalPlaces));
                }
            });

            if (_config.findologicSearch) {
                try {
                    window.sessionStorage.setItem('priceFilter', true);
                    window.sessionStorage.setItem($minInput.attr('name'), $minInput.val());
                    window.sessionStorage.setItem($maxInput.attr('name'), $maxInput.val());
                } catch (e) {
                    console.log(e);
                }
            }

            slider.noUiSlider.on('change', function (values, handle) {
                let value = +values[handle];

                if (handle) {
                    $maxValueText.text(prefix + value.toFixed(decimalPlaces) + suffix);
                    $maxInput.val(value.toFixed(decimalPlaces));
                } else {
                    $minValueText.text(prefix + value.toFixed(decimalPlaces) + suffix);
                    $minInput.val(value.toFixed(decimalPlaces));
                }

                $minInput.attr('disabled', false);
                $maxInput.attr('disabled', false);

                if (_config.findologicSearch) {
                    try {
                        window.sessionStorage.setItem('priceFilter', true);
                        window.sessionStorage.setItem($minInput.attr('name'), $minInput.val());
                        window.sessionStorage.setItem($maxInput.attr('name'), $maxInput.val());
                    } catch (e) {
                        console.log(e);
                    }
                }
            });


            $minInput.on('change', function () {
                let currMax = slider.noUiSlider.get()[1];
                let newMinValue = Number(this.value);
                slider.noUiSlider.set([newMinValue, null]);
                if (newMinValue >= currMax) {
                    if((newMinValue + 1) > maxValue){
                        slider.noUiSlider.set([maxValue, maxValue]);
                        $maxInput.val(maxValue);
                        $minInput.val(maxValue);
                    } else {
                        slider.noUiSlider.set([newMinValue, (newMinValue + 1)]);
                        $maxInput.val((newMinValue + 1));
                    }
                }

                if (_config.findologicSearch) {
                    try {
                        window.sessionStorage.setItem('priceFilter', true);
                        window.sessionStorage.setItem($minInput.attr('name'), $minInput.val());
                    } catch (e) {
                        console.log(e);
                    }
                }
            });

            $maxInput.on('change', function () {
                let currMin = slider.noUiSlider.get()[0];
                let newMaxValue = Number(this.value);
                slider.noUiSlider.set([null, newMaxValue]);
                if (newMaxValue <= currMin) {
                    if((newMaxValue - 1) < minValue){
                        slider.noUiSlider.set([minValue, minValue]);
                        $minInput.val(minValue);
                        $maxInput.val(minValue);
                    } else {
                        slider.noUiSlider.set([(newMaxValue - 1), newMaxValue]);
                        $minInput.val((newMaxValue - 1));
                    }
                }

                if (_config.findologicSearch) {
                    try {
                        window.sessionStorage.setItem('priceFilter', true);
                        window.sessionStorage.setItem($maxInput.attr('name'), $maxInput.val());
                    } catch (e) {
                        console.log(e);
                    }
                }
            });

            if (_config.findologicSearch && window.location.search) {
                $findologicSearch.on('submit', function (e) {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const urlPriceMin = urlParams.get('price[min]');
                    const urlPriceMax = urlParams.get('price[max]');


                    if (urlPriceMin || urlPriceMax) {
                        let storageMinInputVal = window.sessionStorage.getItem($minInput.attr('name'));
                        let storageMaxInputVal = window.sessionStorage.getItem($maxInput.attr('name'));

                        if (storageMaxInputVal){
                            $maxInput.val(storageMaxInputVal);
                        }else{
                            $maxInput.val(urlPriceMax);
                        }

                        if (storageMinInputVal){
                            $minInput.val(storageMinInputVal);
                        }else{
                            $minInput.val(urlPriceMin);
                        }

                    }
                });
            }

        });
    });
}

